/** Canonical 12 Dim Mak meridians for handbook pages and builders. */

import { getDimMakMeridiansBucketName, getSupabaseProjectUrl } from './supabase';
import { buildSupabasePublicObjectUrl } from './courseMediaUrls';

export const DIM_MAK_MERIDIANS = [
  { name: 'Lung', slug: 'lung', screen: 'dim_mak_lung' },
  { name: 'Large Intestine', slug: 'large_intestine', screen: 'dim_mak_large_intestine' },
  { name: 'Stomach', slug: 'stomach', screen: 'dim_mak_stomach' },
  { name: 'Spleen', slug: 'spleen', screen: 'dim_mak_spleen' },
  { name: 'Heart', slug: 'heart', screen: 'dim_mak_heart' },
  { name: 'Small Intestine', slug: 'small_intestine', screen: 'dim_mak_small_intestine' },
  { name: 'Bladder', slug: 'bladder', screen: 'dim_mak_bladder' },
  { name: 'Kidney', slug: 'kidney', screen: 'dim_mak_kidney' },
  { name: 'Pericardium', slug: 'pericardium', screen: 'dim_mak_pericardium' },
  { name: 'Triple Warmer', slug: 'triple_warmer', screen: 'dim_mak_triple_warmer' },
  { name: 'Gallbladder', slug: 'gallbladder', screen: 'dim_mak_gallbladder' },
  { name: 'Liver', slug: 'liver', screen: 'dim_mak_liver' },
];

export const DIM_MAK_COURSE_NAME = 'Dim Mak';
export const DIM_MAK_MERIDIANS_BUCKET = 'dim_mak_meridians';

export function normalizeDimMakMeridianKey(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/\bmeridians?\b/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

export function meridianNameToSlug(name) {
  return normalizeDimMakMeridianKey(name).replace(/\s+/g, '_');
}

export function meridianFromScreenName(screenName) {
  const name = String(screenName || '');
  return DIM_MAK_MERIDIANS.find((m) => m.screen === name) || null;
}

export function meridianFromSlug(slug) {
  const s = String(slug || '').trim().toLowerCase();
  return DIM_MAK_MERIDIANS.find((m) => m.slug === s) || null;
}

export function isExactMeridianNameMatch(a, b) {
  return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
}

export function isSimilarMeridianName(a, b) {
  const ka = normalizeDimMakMeridianKey(a);
  const kb = normalizeDimMakMeridianKey(b);
  if (!ka || !kb) return false;
  return ka === kb;
}

export function findSimilarMeridians(records, candidateName, excludeId) {
  const key = normalizeDimMakMeridianKey(candidateName);
  if (!key) return [];
  return (records || []).filter((row) => {
    if (excludeId != null && Number(row.id) === Number(excludeId)) return false;
    return isSimilarMeridianName(candidateName, row.meridian_name);
  });
}

export function findExactMeridian(records, candidateName, excludeId) {
  return (records || []).find((row) => {
    if (excludeId != null && Number(row.id) === Number(excludeId)) return false;
    return isExactMeridianNameMatch(candidateName, row.meridian_name);
  }) || null;
}

export function suggestedDimMakMeridianImageUrl(meridianName) {
  const name = String(meridianName || '').trim();
  const projectUrl = getSupabaseProjectUrl();
  const bucket = getDimMakMeridiansBucketName();
  if (!name || !projectUrl || !bucket) return '';
  return buildSupabasePublicObjectUrl(projectUrl, bucket, name);
}

export function dimMakMeridianImageCandidates(meridian) {
  const name = String(meridian?.meridian_name || '').trim();
  const main = String(meridian?.main_image || '').trim();
  const projectUrl = getSupabaseProjectUrl();
  const bucket = getDimMakMeridiansBucketName();
  const urls = [];
  const push = (u) => {
    if (u && !urls.includes(u)) urls.push(u);
  };
  if (/^https?:\/\//i.test(main)) push(main);
  else if (main && projectUrl && bucket) {
    push(buildSupabasePublicObjectUrl(projectUrl, bucket, main));
  }
  if (name && projectUrl && bucket) {
    push(buildSupabasePublicObjectUrl(projectUrl, bucket, name));
    push(buildSupabasePublicObjectUrl(projectUrl, bucket, `${name}.jpg`));
    push(buildSupabasePublicObjectUrl(projectUrl, bucket, `${name}.png`));
    push(buildSupabasePublicObjectUrl(projectUrl, bucket, `${name}.jpeg`));
    push(buildSupabasePublicObjectUrl(projectUrl, bucket, `${name}.webp`));
  }
  return urls;
}
